import { findStateIcon } from "@/assets/states/StateIcon";
import { cn } from "@/lib/utils";

interface StateCardProps {
	label: string;
	value: number;
	stateKey: string;
	variant: "red" | "amber" | "green" | "slate";
}

export function StateCard({ label, value, stateKey, variant }: StateCardProps) {
	const variants = {
		red: "border-red-200 bg-red-50 text-red-700",
		amber: "border-amber-200 bg-amber-50 text-amber-700",
		green: "border-green-200 bg-green-50 text-green-700",
		slate: "border-slate-200 bg-slate-50 text-slate-700",
	};

	return (
		<div className={cn("p-2 w-full rounded-lg border", variants[variant])}>
			<div className="flex justify-between items-start">
				<div className="w-7 [&_svg]:w-7 h-7 [&_svg]:h-7">
					{findStateIcon(stateKey)}
				</div>
				<div className={cn("font-bold text-2xl", `text-${variant}-700`)}>
					{value}
				</div>
			</div>
			<h3 className="mt-1 font-medium text-sm">{label}</h3>
		</div>
	);
}
